// @ts-nocheck
import {Column} from 'react-table'

import { useIntl } from 'react-intl'; 
import { Theme } from '../../core/_models';
import { FacilitiesIconHeader } from '../ThemesIconHeader';
import { ThemeActionsCell } from './ThemeActionsCell';
import { ThemeCustomHeader } from './ThemeCustomHeader';


const themesColumns: ReadonlyArray<Column<Theme>> = [
 /* {
    Header: (props) => (
      <ThemeCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.ID' })}
        className='min-w-125px'
      />
    ),
    accessor: '_id',
  },
 */
  {
    Header: (props) => (
      <ThemeCustomHeader
        tableProps={props}
        title={useIntl().formatMessage({ id: 'COLUMNS.NAME' })}
        className='min-w-125px'
      />
    ),
    id: 'translations[0].name',
    Cell: ({ row }) => (
      <span>{row.original.translations?.[0]?.name}</span> 
    ),  },


  {
    Header: (props) => (
      <ThemeCustomHeader tableProps={props} title='' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({...props}) => <ThemeActionsCell id={props.data[props.row.index]._id} />,
  },
]

export {themesColumns}
